import type { Paidol } from 'API';

type PaidolLike = Pick<Paidol, 'isAgaveClient' | 'erpSpeedchain' | 'erpConnectionId'> | null | undefined;

export const isAgaveClient = (paidol: PaidolLike): boolean => paidol?.isAgaveClient ?? false;

// True once a direct-ERP paidol points at a live connection. Kept for the
// connect-page "actively connected" checks; it is NOT the coding-column gate
// (see hasErpCodingUI).
export const isErpConnectionClient = (paidol: PaidolLike): boolean =>
  Boolean(paidol?.erpSpeedchain && paidol?.erpConnectionId != null);

// Coding columns gate. SEE-1042 (Travis decision, overrides AC): the coding
// columns ALWAYS show for a direct-connection paidol — empty until connected +
// synced — and never hide on disconnect, for consistency across every direct
// ERP (QBO / Intacct / Spectrum / Vista / QBD; Yash confirmed Intacct behaved
// the same). So this keys off `erpSpeedchain` (the paidol IS a direct-ERP
// client), not `erpConnectionId` — a disconnect that clears the connection
// pointer must not yank the columns out from under the AM/customer.
export const hasErpCodingUI = (paidol: PaidolLike): boolean =>
  isAgaveClient(paidol) || (paidol?.erpSpeedchain ?? false);
